import { DATA_BASE_URL } from '@lib/constants';

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden py-20 sm:py-24 lg:py-32 px-4 sm:px-6 lg:px-8">
      {/* Dynamic gradient background with sports energy */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(135deg, var(--color-theme-1) 0%, var(--color-accent-1) 50%, var(--color-theme-2) 100%)'
        }}
      >
        {/* Animated accent shapes */}
        <div
          className="absolute top-0 left-1/4 w-96 h-96 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse"
          style={{ backgroundColor: 'var(--color-accent-4)', animationDuration: '3s' }}
        ></div>
        <div
          className="absolute -bottom-8 right-1/4 w-96 h-96 rounded-full mix-blend-multiply filter blur-3xl opacity-15 animate-pulse"
          style={{ backgroundColor: 'var(--color-accent-3)', animationDuration: '4s' }}
        ></div>
      </div>

      <div className="container mx-auto relative z-10 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Hero Content */}
          <div className="space-y-6 sm:space-y-8">
            <div className="space-y-4 sm:space-y-6">
              <div className="space-y-2 sm:space-y-3">
                <h1
                  className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-heading font-extrabold tracking-tight"
                  style={{ color: 'var(--color-heading)' }}
                >
                  Varsity Badminton
                </h1>
                <p
                  className="text-lg sm:text-2xl md:text-3xl font-semibold"
                  style={{ color: 'var(--color-accent-6)' }}
                >
                  ISM Athletics | Team Player
                </p>
              </div>
            </div>

            {/* Description */}
            <p
              className="text-base sm:text-lg leading-relaxed max-w-2xl"
              style={{ color: 'var(--color-subtle)' }}
            >
              Representing International School Manila (ISM) in competitive badminton.
              Competing at regional tournaments including IASAS Malaysia 2024, Pre-IASAS Thailand 2025 and IASAS Singapore 2025, demonstrating
              teamwork, agility, and sportsmanship on the court.
            </p>

            {/* Quick Stats */}
            <div className="grid grid-cols-3 gap-3 sm:gap-6 pt-2 sm:pt-4">
              <div className="text-center space-y-1 sm:space-y-2">
                <div
                  className="text-2xl sm:text-4xl font-bold"
                  style={{ color: 'var(--color-accent-6)' }}
                >
                  3+
                </div>
                <div
                  className="text-xs sm:text-sm font-medium uppercase tracking-wide"
                  style={{ color: 'var(--color-muted)' }}
                >
                  Years
                </div>
              </div>
              <div className="text-center space-y-1 sm:space-y-2">
                <div
                  className="text-2xl sm:text-4xl font-bold"
                  style={{ color: 'var(--color-accent-6)' }}
                >
                  IASAS
                </div>
                <div
                  className="text-xs sm:text-sm font-medium uppercase tracking-wide"
                  style={{ color: 'var(--color-muted)' }}
                >
                  Tournament
                </div>
              </div>
              <div className="text-center space-y-1 sm:space-y-2">
                <div
                  className="text-2xl sm:text-4xl font-bold"
                  style={{ color: 'var(--color-accent-6)' }}
                >
                  ISM
                </div>
                <div
                  className="text-xs sm:text-sm font-medium uppercase tracking-wide"
                  style={{ color: 'var(--color-muted)' }}
                >
                  Team
                </div>
              </div>
            </div>
          </div>

          {/* Hero Image */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-none">
              <div
                className="relative rounded-2xl overflow-hidden shadow-card-hover"
                style={{
                  borderColor: 'var(--color-accent-4)',
                  borderWidth: '2px',
                  borderStyle: 'solid'
                }}
              >
                <img
                  src={`${DATA_BASE_URL}/data/badminton/photos/varsity_badminton.webp`}
                  alt="Varsity Badminton Team"
                  className="w-full h-[300px] sm:h-[400px] lg:h-[500px] object-cover"
                  loading="lazy"
                />
                {/* Overlay gradient */}
                <div
                  className="absolute inset-0 opacity-10"
                  style={{
                    background: 'linear-gradient(to top, var(--color-accent-9), transparent)'
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
